module.exports = {
      id: "bathroom-usage",
      viewBox: "0 0 20.4 15.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#bathroom-usage",
      toString: function () {
        return this.url;
      }
    }